import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'dva'
import Top1 from './top1'
import Top2 from './top2'
import Top3 from './top3'
import Top4 from './top4'
import Top5 from './top5'
import ServiceModal from '@/components/ServiceModal';
import { useHistory } from 'react-router-dom'

import Swiper from 'swiper'
import 'swiper/css/swiper.css'
import './index.less'

function Home(props) {
  const history = useHistory()

  useEffect(() => {
    const mySwiper = new Swiper('.home-banner', {
      autoplay: {
        delay: 5000, // 自动切换的时间间隔，单位ms
        disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay。默认为true：停止。
      }, //可选选项，自动滑动
      speed: 800, // 切换速度
      loop: true, // 循环模式选项
      parallax: true, // 切换层次感
      pagination: {
        type: 'bullets',
        el: '.swiper-pagination',
        clickable: true,
      },
    })
    //鼠标覆盖停止自动切换
    mySwiper.el.onmouseover = function () {
      mySwiper.autoplay.stop()
    }

    //鼠标离开开始自动切换
    mySwiper.el.onmouseout = function () {
      mySwiper.autoplay.start()
    }
  }, [])
  return (
    <div className='home'>
      <Helmet>
        <title>数秦科技_全流程可信数据技术与产品服务商</title>
        <meta
          name="keywords"
          content="区块链，数据资产，可信数据，新质生产力，可信数据空间，RWA"
        />
        <meta
          name="description"
          content="为客户提供智能便捷、安全可靠的可信数据基础设施和高价值、高质量的全流程数据资产入表运营服务，助力企业实现可信数据资产化，提升数据资本化能力。"
        />
      </Helmet>
      <div className="home-banner swiper-container">
        <div className="swiper-wrapper">
             <div className="swiper-slide" key='banner1'>
                  <div
                    className="home-banner-bg banner-bg1"
                  >
                    <div style={{textAlign: 'center', width: '100%'}}><img src={require('../../assets/image/home/banner1_text.png')} style={{height: 86, margin: '128px auto 40px'}} /></div>
                    <div className='btn-box' style={{width: '100%'}}>
                        <div className='banner-btn-blue' onClick={() => history.push('/about')}>查看更多</div>
                        <ServiceModal>
                          <div className='banner-btn-white'>立即咨询</div>
                        </ServiceModal>
                      </div>
                  </div>
              </div>
              <div className="swiper-slide" key='banner2'>
                  <div
                    className="home-banner-bg banner-bg2"
                  >
                    <div style={{textAlign: 'center', width: '100%'}}><img src={require('../../assets/image/home/banner2_text.png')} style={{height: 86, margin: '128px auto 40px'}} /></div>
                    <div className='btn-box' style={{width: '100%'}}>
                    <ServiceModal> <div className='banner-btn-blue'  onClick={() => history.push('/trustedDataCirculation')}>查看更多</div></ServiceModal>
                      </div>
                  </div>
              </div>
              <div className="swiper-slide" key='banner3'>
                  <div
                    className="home-banner-bg banner-bg3"
                  >
                    <div style={{textAlign: 'center', width: '100%'}}><img style={{height: 86, margin: '128px auto 40px'}} /></div>
                    <div className='btn-box' style={{width: '100%', marginTop: '30px'}}>
                    <div className='banner-btn-blue'  onClick={() => window.open('https://mp.weixin.qq.com/s/0KT4ghIO6QNNQ-W-yUew9w')}>查看更多</div>
                      </div>
                  </div>
              </div>
        </div>
        <div className="swiper-pagination"></div>
        <div className='home-banner-bottom'>
            <div className="banner-bottom-inner">
              <div className='bottom-item'>
                <p>为什么选择数秦</p>
                <span>领先的全流程可信数据技术与服务运营商</span>
              </div>
              <div className='bottom-item-line'></div>
              <div className='bottom-item'>
                <p>可信数据空间</p>
                <span>融合区块链、大数据、人工智能及隐私计算</span>
              </div>
              <div className='bottom-item-line'></div>
              <div className='bottom-item'>
                <p>知识产权</p>
                <span>10年技术沉淀，200+专利，持续创新</span>
              </div>
              <div className='bottom-item-line'></div>
              <div className='bottom-item'>
                <p>行长单位</p>
                <span>国家主链星火·链网的核心支撑企业</span>
              </div>
          </div>
        </div>
      </div>
      <Top1 />
      <Top2 />
      <Top3 />
      <Top4 />
      <Top5 />
    </div>
  )
}

Home.getInitialProps = async (ctx) => {
  // ssr渲染模式只在服务端通过Node获取数据，csr渲染模式只在客户端通过http请求获取数据，getInitialProps方法在整个页面生命周期只会执行一次
  const { store } = ctx
  await store.dispatch({
    type: 'home/getBannerList',
    payload: { pageSize: 5, pageNum: 1, status: 0 },
  })
  await store.dispatch({
    type: 'home/getMediaList',
    payload: { pageSize: 5, pageNum: 1, status: 0 },
  })
}

const mapStateToProps = (state) => ({
  bannerList: state.home.bannerlist,
  mediaList: state.home.medialist,
})

export default connect(mapStateToProps)(Home)
